// ANCHOR Base
import { Block } from 'baseui/block';
import { LabelLarge } from 'baseui/typography';

// ANCHOR Models
import { useFormDataType } from '@lyon/scoped-models/form/FormData';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { Divider } from '@lyon/components/utils/Divider';
import { LyonUpdateFormScoringPolicy } from './LyonUpdateFormScoringPolicy';
import { LyonUpdateFormAllowedAttempt } from './LyonUpdateFormAllowedAttempt';
import { LyonUpdateFormTimeLimit } from './LyonUpdateFormTimeLimit';
import { LyonUpdateFormSequential } from './LyonUpdateFormSequential';
import { LyonUpdateFormShuffleQuestion } from './LyonUpdateFormShuffleQuestion';
import { LyonUpdateFormTextSelection } from './LyonUpdateFormTextSelection';
import { LyonUpdateFormShowScore } from './LyonUpdateFormShowScore';
import { LyonUpdateFormShowCorrectResponse } from './LyonUpdateFormShowCorrectResponse';
import { LyonUpdateFormShowRankPercentile } from './LyonUpdateFormShowRankPercentile';
import { LyonUpdateFormOneTimeResult } from './LyonUpdateFormOneTimeResult';
import { LyonUpdateFormShowAfterRegrade } from './LyonUpdateFormShowAfterRegrade';

export const LyonUpdateFormOptionQuiz = constant(() => {
  const formType = useFormDataType();

  if (formType !== 'quiz') {
    return null;
  }

  return (
    <>
      <Divider />
      <Block marginTop="24px">
        <LabelLarge>
          Quiz-specific settings
        </LabelLarge>
        <LyonUpdateFormShuffleQuestion />
        <LyonUpdateFormTextSelection />
        <LyonUpdateFormSequential />
        <LyonUpdateFormTimeLimit />
        <LyonUpdateFormAllowedAttempt />
        <LyonUpdateFormScoringPolicy />
        <LyonUpdateFormShowScore />
        <LyonUpdateFormShowCorrectResponse />
        <LyonUpdateFormShowRankPercentile />
        <LyonUpdateFormOneTimeResult />
        <LyonUpdateFormShowAfterRegrade />
      </Block>
    </>
  );
});
